import { requestMethods , formDataMethods } from './requestEncapsulation';

// 版权登记添加新作者(个人)
export const addAuthorPersonal = (params) => { return requestMethods("post", '/article/addAuthorPersonal' , params , true)}

// 版权登记添加新作者(企业)
export const addAuthorEnterprise = (params) => { return requestMethods("post", '/article/addAuthorEnterprise' , params , true)}

// 开发票
export const invoiceInvoice = (params) => { return requestMethods("post", '/invoice/invoice' , params , true)}

// 撤销
export const invoiceToBackoutInvoice = (params) => { return requestMethods("post", '/invoice/backoutInvoice' , params)}

// 获取开票记录列表
export const invoiceInvoiceList = (params) => { return requestMethods("post", '/invoice/invoiceList' , params)}

// 获取待开票列表
export const invoiceToBeInvoiceList = (params) => { return requestMethods("post", '/invoice/toBeInvoiceList' , params)}

// 提现
export const withdraWithdrawal = (params) => { return requestMethods("post", '/withdrawal/withdrawal' , params , true)}

// 添加提现方式
export const withdrawalAddWay = (params) => { return requestMethods("post", '/withdrawal/addWay' , params , true)}

// 提现方式详情
export const withdrawalSelectWayByUserCode = (params) => { return requestMethods("post", '/withdrawal/selectWayByUserCode' , params)}

// 可提现余额查询
export const withdrawalAmount = (params) => { return requestMethods("post", '/withdrawal/amount' , params)}

// 获取提现记录列表
export const withdrawalSelectWithdrawalList = (params) => { return requestMethods("post", '/withdrawal/selectWithdrawalList' , params)}

// 获取文章信息
export const articleGetArticleInfo = (params) => { return requestMethods("post", '/article/getArticleInfo' , params)}

// 获取订单支付状态
export const getUserOrderList = (params) => { return requestMethods("post", '/order/getUserOrderList' , params)}

// 获取订单支付状态
export const orderGeyOrderPayStatus = (params) => { return requestMethods("post", '/order/geyOrderPayStatus' , params)}

// 删除上链
export const articleDeleteLink= (params) => { return requestMethods("post", '/article/deleteLink' , params)}

// 提交效验
export const articleLinkSubmitValid = (params) => { return requestMethods("post", '/article/linkSubmitValid' , params)}

// 支付订单生成新
export const orderPay = (params) => { return requestMethods("post", '/order/pay' , params)}

// 添加文章定价信息
export const addWorksPriceList = (params) => { return requestMethods("post", '/price/addWorksPriceList' , params,true)}

// 获取文章定价信息
export const priceGetWorksPriceList = (params) => { return requestMethods("post", '/price/getWorksPriceList' , params)}

// 添加文章套餐定价信息
export const addWorksComboPriceList = (params) => { return requestMethods("post", '/price/addWorksComboPriceList' , params,true)}

// 获取文章套餐定价信息
export const priceGetWorksComboPriceList = (params) => { return requestMethods("post", '/price/getWorksComboPriceList' , params)}

// 上链文章查询
export const articleGetUserArticle = (params) => { return requestMethods("post", '/article/getUserArticle' , params)}

// 版权登记添加作者
export const articleAddAuthor = (params) => { return requestMethods("post", '/article/addAuthor' , params , true)}

// 版权登记删除作者
export const articleDeleteAuthor = (params) => { return requestMethods("post", '/article/deleteAuthor' , params)}

// 提交审核
export const articleLinkSubmit = (params) => { return requestMethods("post", '/article/linkSubmit' , params)}

// 版权登记第三步，文件生成
export const articleUploadDETThree = (params) => { return requestMethods("post", '/article/uploadDETThree' , params , true)}

// 版权登记第二步，内容上传提交
export const articleUploadDETTwo = (params) => { return formDataMethods("post", '/article/uploadDETTwo' , params)}

// 版权登记内容查询
export const articleGetWorksInfo = (params) => { return requestMethods("post", '/article/getWorksInfo' , params)}

// 版权登记第一步，审核批次创建
export const articleUploadDETOne = (params) => { return requestMethods("post", '/article/uploadDETOne' , params)}

// 上传上链文件
export const uploadFilePath = (params) => { return formDataMethods("post", '/upload/filePath' , params )}

// 手机号注册
export const loginPhoneRegister = (params) => { return requestMethods("post", '/user/phoneRegister' , params , true)}

// 发送验证码
export const smsTemplateSendMsgSecond = (params) => { return requestMethods("post", '/smsTemplate/sendMsgSecond' , params)}

// 登录
export const userLogin = (params) => { return requestMethods("post", '/user/login' , params, true )}

// 账号个人认证
export const addUserPersonalAuthentication = (params) => { return formDataMethods("post", '/user/addUserPersonalAuthentication' , params )}

// 账号企业认证
export const addUserEnterpriseAuthentication = (params) => { return formDataMethods("post", '/user/addUserEnterpriseAuthentication' , params )}

// 找回密码
export const userFindPassWord = (params) => { return requestMethods("post", '/user/findPassWord' , params ,true )}

// 修改密码
export const userUpdatePassWord = (params) => { return requestMethods("post", '/user/updatePassWord' , params ,true)}

// 获取用户信息
export const getUserInfo = (params) => { return requestMethods("post", '/user/getUserInfo' , params )}

// 账号个人认证
export const updateUserPersonalAuthentication = (params) => { return formDataMethods("post", '/user/updateUserPersonalAuthentication' , params ,true )}

// 账号企业认证
export const updateUserEnterpriseAuthentication = (params) => { return formDataMethods("post", '/user/updateUserEnterpriseAuthentication' , params ,true )}

export const uploadFile = (params) => { return requestMethods("post", '/article/importArticle' , params,true)}

// 确认导入
export const confirmImport = (params) => { return requestMethods("post", '/article/confirmImport' , params)}

// 导入记录
export const importRecord = (params) => { return requestMethods("post", '/article/importRecord' , params)}
// 导入组
export const importGroupRecord = (params) => { return requestMethods("get", '/article/importGroupRecord' , params)}



